import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AmIconModule } from '../am-icon/am-icon.module';
import { ThemeToggleComponent } from './theme-toggle.component';

@NgModule({
  declarations: [ThemeToggleComponent],
  imports: [CommonModule, AmIconModule, MatButtonModule, MatTooltipModule],
  exports: [ThemeToggleComponent],
})
export class ThemeToggleModule {}
